import { User, WecomRelationType } from '@/models/user';
import {
  AlipayCircleFilled,
  MessageOutlined,
  NodeExpandOutlined,
  WechatFilled,
  WechatWorkOutlined,
} from '@ant-design/icons';
import { Space } from 'antd';
import { createStyles } from 'antd-style';
import { SpaceProps } from 'antd/es/space';
import React, { CSSProperties } from 'react';

export type Props = {
  user: User;
  className?: string;
  style?: CSSProperties;
  spaceProps?: SpaceProps;
  showReport?: boolean;
  showAlipay?: boolean;
  showWxOpenId?: boolean;
  showMobile?: boolean;
};

const useStyle = createStyles(({ token, css, cx }) => {
  const text = cx(css`
    color: ${token.colorTextBase};
  `);
  const icon = cx(css`
    font-size: 1.1em;
    margin-right: 3px;
    &.mpOpenid,
    &.weixinOpenid {
      color: #31ac38;
    }
    &.wecomId {
      color: #0082ef;
    }
    &.alipayId,
    &.moremeCid {
      color: #2f77ff;
    }
    &.mobile {
      color: #ff8f2f;
    }
  `);
  return {
    text,
    icon,
    invalid: css`
      color: ${token.colorTextDisabled};
      .${text}, .${icon} {
        color: ${token.colorTextDisabled};
      }
    `,
  };
});

const UserRelationBar: React.FC<Props> = ({
  user,
  className = '',
  style = {},
  showReport = true,
  showAlipay = true,
  showWxOpenId = true,
  showMobile = false,
  spaceProps = {},
}: Props) => {
  const { styles, cx } = useStyle();
  if (!user) return <>无效用户信息</>;
  return (
    <Space size={5} {...spaceProps} className={className}>
      <span className={cx({ [styles.invalid]: !user.mpOpenid })}>
        <WechatFilled className={cx(styles.icon, 'mpOpenid')} />
        <span className={cx(styles.text)}>服务号</span>
      </span>
      {showWxOpenId && (
        <span className={cx({ [styles.invalid]: !user.weixinOpenid })}>
          <WechatFilled className={cx(styles.icon, 'weixinOpenid')} />
          <span className={cx(styles.text)}>小程序</span>
        </span>
      )}

      <span className={cx({ [styles.invalid]: !user.wecomId })}>
        <WechatWorkOutlined className={cx(styles.icon, 'wecomId')} />
        <span className={cx(styles.text)}>企微</span>
        {user.wecomId && user.wecomRelationType === WecomRelationType.NOT_FOLLOWED ? (
          <b className="emphasize red">流失</b>
        ) : null}
      </span>
      {showAlipay && (
        <span className={cx({ [styles.invalid]: !user.alipayId })}>
          <AlipayCircleFilled className={cx(styles.icon, 'alipayId')} />
          <span className={cx(styles.text)}>支付宝</span>
        </span>
      )}
      {showReport && (
        <span className={cx({ [styles.invalid]: !user.moremeCid })}>
          <NodeExpandOutlined className={cx(styles.icon, 'moremeCid')} />
          <span className={cx(styles.text)}>检测仪</span>
        </span>
      )}
      {showMobile && (
        <span className={cx({ [styles.invalid]: !user.mobile })}>
          <MessageOutlined className={cx(styles.icon, 'mobile')} />
          <span className={cx(styles.text)}>短信</span>
        </span>
      )}
    </Space>
  );
};

export default UserRelationBar;
